import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {KPIIconTypes} from "@/components/KPIIcon/KPIIcon.types.ts";
import {SummaryBar} from "@/components/summaryBar/SummaryBar.tsx";
import {SummaryBlock} from "@/components/summaryBar/SummaryBar.types.ts";
import {IncidentsListStats} from "@/lib/queries/statuspages.ts";

interface IncidentsSummaryBarProps {
  stats: IncidentsListStats;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const IncidentsSummaryBar = ({stats, filterSets, onFilterSetChange}: IncidentsSummaryBarProps) => {
  const summaryBlocks: SummaryBlock<IncidentsListStats>[] = [
    {
      applyFilterset: {update_types: ["active"]},
      title: "Total Active Incidents",
      icon: KPIIconTypes.INCIDENTS_ACTIVE,
      renderStat: (stats) => <>{stats.active}</>,
    },
    {
      applyFilterset: {update_types: ["investigating"]},
      title: "Investigating",
      icon: KPIIconTypes.INCIDENTS_INVESTIGATING,
      renderStat: (stats) => <>{stats.investigating}</>,
    },
    {
      applyFilterset: {update_types: ["monitoring"]},
      title: "Monitoring",
      icon: KPIIconTypes.INCIDENTS_MONITORING,
      renderStat: (stats) => <>{stats.monitoring}</>,
    },
    {
      applyFilterset: {update_types: ["identified"]},
      title: "Identified",
      icon: KPIIconTypes.INCIDENTS_IDENTIFIED,
      renderStat: (stats) => <>{stats.identified}</>,
    },
    {
      applyFilterset: {update_types: ["maintenance"]},
      title: "Maintenance Enabled",
      icon: KPIIconTypes.INCIDENTS_MAINTENANCE,
      renderStat: (stats) => <>{stats.maintenance}</>,
    },
    {
      applyFilterset: {update_types: ["resolved"]},
      title: "Resolved",
      icon: KPIIconTypes.INCIDENTS_RESOLVED,
      renderStat: (stats) => <>{stats.resolved}</>,
    },
  ];

  return (
    <SummaryBar
      className={"mb-3"}
      stats={stats}
      summaryBlocks={summaryBlocks}
      columns={{sm: 1, md: 2, lg: 3, xl: 3, xxl: 3}}
      filterSets={filterSets}
      onFilterSetChange={onFilterSetChange}
    />
  );
};
